import React from 'react';
import ReactDOM from 'react-dom';
import { TextField, ThemeProvider } from '@mui/material';
import { createDebouncedUpdate, updateCellProperty, updateOutageEntry } from '../utils/InspectorUtils';

export function renderTimeInput(field, cell, theme) {
  const container = document.createElement('div');
  const TimeInputField = () => {
    const initialValue = cell.get(field.path) || field.defaultValue || '00:00';
    const [value, setValue] = React.useState(initialValue);
    const [debouncedValue] = React.useState(() =>
      createDebouncedUpdate((newValue, updateGraphImmediately) => {
        const cellId = field.cellId;
        const graph = cell.graph;

        if (field.group === 'outages') {
          updateOutageEntry(graph, cellId, 0, field.path, newValue);
        } else {
          updateCellProperty(cell, field, field.path, newValue, {
            silent: !updateGraphImmediately,
          });
        }
      })
    );

    const handleChange = (e, updateGraphImmediately) => {
      const newValue = e.target.value;
      setValue(newValue);
      debouncedValue(newValue, updateGraphImmediately);
    };

    React.useEffect(() => () => debouncedValue.cancel(), [debouncedValue]);

    return (
      <ThemeProvider theme={theme}>
        <TextField
          fullWidth
          size="small"
          type="time"
          label={field.label}
          variant="outlined"
          value={value}
          onBlur={(event) => handleChange(event, true)}
          onChange={(event) => handleChange(event, false)}
          disabled={field.readOnly}
          required={field.required}
          error={field.required && !value}
          helperText={field.required && !value ? 'Ce champ est requis' : ''}
          inputProps={{
            step: 60, // steps of 1 minute
            'data-cy': field.attributes?.['data-cy'],
            onCompositionStart: (e) => e.stopPropagation(),
            onCompositionEnd: (e) => e.stopPropagation(),
          }}
        />
      </ThemeProvider>
    );
  };
  ReactDOM.render(<TimeInputField />, container);
  return container;
}
